import utils from "../../../utils/utils.js";

export default {
  async fetchSuperUserXStreams(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetXStreams?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserXStreams", responseData.data);
  },
  async fetchSuperUserXStreamRules(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetXStreamRules?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserXStreamRules", responseData.data);
  },

  async fetchSuperUserXStreamLastStatus(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetXStreamLastStatus`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserXStreamLastStatus", response.data);
  },
};
